var map = {
	"./ADJUSTMENT_APPLIED.png": 918,
	"./BILLING_ADDRESS_UPDATE.png": 5031,
	"./CARD_DUE_TO_EXPIRE.png": 2940,
	"./CARD_EXPIRED.png": 7604,
	"./CREDIT_LIMIT_ALERT_100_WEB.png": 5035,
	"./CREDIT_LIMIT_ALERT_70_WEB.png": 5034,
	"./CROSS_SELL_REQUEST.png": 2216,
	"./DEFAULT_CARD_CHANGED.png": 4870,
	"./NEW_CARD_ADDED.png": 2849,
	"./NEW_ORDER.png": 7331,
	"./NEW_SIM_REPLACEMENT.png": 233,
	"./NUSISANCE_CALLS_MONITORING_UPDATE.png": 8950,
	"./PERSONAL_DETAILS_UPDATE.png": 5871,
	"./TERMINATION_SCHEDULE.png": 7400,
	"./UNPAID_BILL.png": 4633,
	"./cancel.png": 2684,
	"./card-alt.png": 8661,
	"./card.png": 5969,
	"./id.png": 3175,
	"./portin.png": 9400,
	"./unpaid.png": 5857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 891;